<script setup lang="ts">
const {t} = useI18n()
const localePath = useLocalePath()
const authClient = useAuthClient()
const session = authClient.useSession()

async function logOut() {
  await authClient.signOut()
  await navigateTo(localePath('/'))
}
</script>

<template>
  <header class="border-b border-default">
    <div class="mx-auto max-w-6xl px-4 py-4 flex items-center justify-between gap-4">
      <NuxtLinkLocale to="/" class="text-xl font-bold text-primary">{{ t('platform.nav.brand') }}</NuxtLinkLocale>
      <!-- the session is only known in the browser -->
      <ClientOnly>
        <nav :aria-label="t('platform.nav.mainNavigation')" class="flex items-center gap-3">
          <template v-if="session.data">
            <UButton :to="localePath('/stores')" variant="ghost" color="neutral">{{ t('platform.nav.stores') }}</UButton>
            <UButton variant="outline" color="neutral" @click="logOut">{{ t('platform.nav.logout') }}</UButton>
          </template>
          <template v-else>
            <UButton :to="localePath('/login')" variant="ghost" color="neutral">{{ t('platform.nav.login') }}</UButton>
            <UButton :to="localePath('/signup')">{{ t('platform.nav.signUp') }}</UButton>
          </template>
        </nav>
      </ClientOnly>
    </div>
  </header>
</template>
